<template>
  <div v-show="show" style="padding: 15px;">
    <el-radio-group v-model="method" @change="changeMethod">
      <el-radio label="1" :disabled="disabled" border>凭证支付</el-radio>
      <el-radio label="2" border>余额支付</el-radio>
    </el-radio-group>
    <div style="padding-top: 15px;">
      <creditPay v-show="method=='1'" ref="CreditPayRef" @hideModel="hideModel" />
      <netBusiness v-show="method=='2'" ref="CashMoneyRef" :codes="codes" @hideModel="hideModel" />
    </div>
  </div>
</template>
<script>
import netBusiness from './netBusiness.vue'
import creditPay from './creditPay.vue'

import { getMayiCreditBalance } from '@/api/InternetBanking'
export default {
  name: 'AllocateOil',
  components: {
    netBusiness,
    creditPay
  },
  data() {
    return {
      method: '',
      tabPaneVal: '',
      disabled: true,
      codes: [],
      updating: false,
      form: {
        dto: {
          smsCode: ''
        }
      },
      item: {},
      show:false
    }
  },
  methods: {
    hideModel(url){
      this.$emit("hideModel",url)
    },
    init(codes) {
      const rLoading = this.openLoading()
      this.codes = codes
      this.show = false
      // console.log(this.codes)
      // 凭证支付判断
      getMayiCreditBalance({ orderDetailCodes: this.codes }).then(
        (response) => {
          this.method = '1'
          let data = response.data
          // this.$message({ message: response.msg, type: "success" });
          let item = {
            orderDetailCodes: this.codes,
            freight: response.data.freight,
            deliveryCashFee: response.data.deliveryCashFee,
            allotAmount: response.data.allotAmount,
            allotOil: response.data.allotOil
          }
          this.item = item
          if (data.useMayiCredit==='1' && data.whetherMeets=="true") {
            this.show = true
            // 满足
            rLoading.close()
            this.disabled = false
            this.$refs.CreditPayRef.getInfo(this.item)
          } else {
            this.show = true
            this.method = '2'
            this.disabled = true
            // 余额支付判断
            rLoading.close()
            this.ModelBusiness = true
            this.$refs.CashMoneyRef.getInfo(this.item)
          }
        }
      )
    },
    changeMethod(val) {
      this.tabPaneVal = ''
      switch (val) {
        case '1':
          // 凭证支付判断
          this.$refs.CreditPayRef.getInfo(this.item)
          // getMayiCreditBalance({orderDetailCodes:this.codes}).then(response => {
          //   rLoading.close();
          //   let data = response.data;
          //   // this.$message({ message: response.msg, type: "success" });
          //   if(data.whetherMeets){ // 满足
          //     this.disabled = false
          //     this.tabPaneVal = val
          //     this.item={
          //       orderDetailCodes:this.codes,
          //       freight:response.data.freight,
          //       deliveryCashFee:response.data.deliveryCashFee,
          //       allotAmount:response.data.allotAmount,
          //       allotOil:response.data.allotOil
          //     }
          //     this.$refs.CreditPayRef.getInfo(this.item);
          //   }else{
          //     this.disabled = true
          //   }
          // })
          break
        case '2':
          // 余额支付判断
          this.ModelBusiness = true;
          this.$refs.CashMoneyRef.getInfo(this.item);
          this.tabPaneVal = val
          break
      }
    }
  }
}
</script>
